module.exports = __webpack_public_path__ + "img/carshina21_11.c239e9e6.jpg";